import React from 'react';

const USMap = ({ selectedMetric, stateData, onStateClick, selectedState }) => {
    const getStateColor = (stateCode, metric, data) => {
        if (!metric || !data || !data[stateCode]) {
            return '#ccc';
        }

        const value = data[stateCode];
        
        // Handle categorical data with specific color schemes
        if (metric === 'marijuana') {
            if (value === 'Legal') return '#4CAF50';
            if (value === 'Medical only') return '#FFC107';
            return '#F44336';
        }

        if (metric === 'deathPenalty') {
            if (value === 'Abolished') return '#4CAF50';
            if (value === 'Legal (Moratorium)') return '#FF9800';
            return '#F44336';
        }

        if (metric === 'gunLawStrength') {
            const gradeColors = {
                'A': '#4CAF50', 'A-': '#66BB6A', 'A+': '#2E7D32',
                'B': '#8BC34A', 'B-': '#9CCC65', 'B+': '#689F38',
                'C': '#FFC107', 'C-': '#FFD54F', 'C+': '#FFA000',
                'D': '#FF9800', 'D-': '#FFCC02', 'D+': '#FB8C00',
                'F': '#F44336'
            };
            return gradeColors[value] || '#ccc';
        }

        // For numeric data, calculate color based on range
        const values = Object.values(data).filter(v => typeof v === 'number');
        const minValue = Math.min(...values);
        const maxValue = Math.max(...values);
        
        if (minValue === maxValue) return '#4CAF50';
        
        const percentage = (value - minValue) / (maxValue - minValue);
        const red = Math.floor(255 * (1 - percentage));
        const green = Math.floor(255 * percentage);
        
        return `rgb(${red}, ${green}, 100)`;
    };

    const getStrokeStyle = (stateCode) => {
        if (selectedState === stateCode) {
            return { strokeWidth: '3', stroke: 'yellow' };
        }
        return { strokeWidth: '1', stroke: 'black' };
    };

    return (
        <div style={{ textAlign: 'center', margin: '20px 0' }}>
            <svg width="900" height="500" viewBox="0 0 900 500">
                {/* Northwest */}
                <rect 
                    id="WA" 
                    x="50" y="50" width="60" height="40" 
                    fill={getStateColor('WA', selectedMetric, stateData)}
                    {...getStrokeStyle('WA')}
                    onClick={() => onStateClick('WA')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="80" y="75" textAnchor="middle" fontSize="12">WA</text>
                
                <rect 
                    id="OR" 
                    x="50" y="95" width="60" height="40" 
                    fill={getStateColor('OR', selectedMetric, stateData)}
                    {...getStrokeStyle('OR')}
                    onClick={() => onStateClick('OR')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="80" y="120" textAnchor="middle" fontSize="12">OR</text>
                
                <rect 
                    id="CA" 
                    x="50" y="140" width="60" height="80" 
                    fill={getStateColor('CA', selectedMetric, stateData)}
                    {...getStrokeStyle('CA')}
                    onClick={() => onStateClick('CA')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="80" y="185" textAnchor="middle" fontSize="12">CA</text>
                
                <rect 
                    id="ID" 
                    x="115" y="50" width="60" height="60" 
                    fill={getStateColor('ID', selectedMetric, stateData)}
                    {...getStrokeStyle('ID')}
                    onClick={() => onStateClick('ID')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="145" y="85" textAnchor="middle" fontSize="12">ID</text>
                
                <rect 
                    id="NV" 
                    x="115" y="115" width="60" height="60" 
                    fill={getStateColor('NV', selectedMetric, stateData)}
                    {...getStrokeStyle('NV')}
                    onClick={() => onStateClick('NV')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="145" y="150" textAnchor="middle" fontSize="12">NV</text>
                
                <rect 
                    id="UT" 
                    x="180" y="115" width="60" height="60" 
                    fill={getStateColor('UT', selectedMetric, stateData)}
                    {...getStrokeStyle('UT')}
                    onClick={() => onStateClick('UT')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="210" y="150" textAnchor="middle" fontSize="12">UT</text>
                
                <rect 
                    id="AZ" 
                    x="180" y="180" width="60" height="60" 
                    fill={getStateColor('AZ', selectedMetric, stateData)}
                    {...getStrokeStyle('AZ')}
                    onClick={() => onStateClick('AZ')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="210" y="215" textAnchor="middle" fontSize="12">AZ</text>
                
                <rect 
                    id="MT" 
                    x="180" y="50" width="80" height="60" 
                    fill={getStateColor('MT', selectedMetric, stateData)}
                    {...getStrokeStyle('MT')}
                    onClick={() => onStateClick('MT')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="220" y="85" textAnchor="middle" fontSize="12">MT</text>
                
                <rect 
                    id="WY" 
                    x="245" y="115" width="70" height="60" 
                    fill={getStateColor('WY', selectedMetric, stateData)}
                    {...getStrokeStyle('WY')}
                    onClick={() => onStateClick('WY')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="280" y="150" textAnchor="middle" fontSize="12">WY</text>
                
                <rect 
                    id="CO" 
                    x="245" y="180" width="70" height="60" 
                    fill={getStateColor('CO', selectedMetric, stateData)}
                    {...getStrokeStyle('CO')}
                    onClick={() => onStateClick('CO')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="280" y="215" textAnchor="middle" fontSize="12">CO</text>
                
                <rect 
                    id="NM" 
                    x="245" y="245" width="70" height="60" 
                    fill={getStateColor('NM', selectedMetric, stateData)}
                    {...getStrokeStyle('NM')}
                    onClick={() => onStateClick('NM')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="280" y="280" textAnchor="middle" fontSize="12">NM</text>
                
                <rect 
                    id="ND" 
                    x="265" y="50" width="70" height="40" 
                    fill={getStateColor('ND', selectedMetric, stateData)}
                    {...getStrokeStyle('ND')}
                    onClick={() => onStateClick('ND')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="300" y="75" textAnchor="middle" fontSize="12">ND</text>
                
                <rect 
                    id="SD" 
                    x="320" y="95" width="70" height="40" 
                    fill={getStateColor('SD', selectedMetric, stateData)}
                    {...getStrokeStyle('SD')}
                    onClick={() => onStateClick('SD')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="355" y="120" textAnchor="middle" fontSize="12">SD</text>
                
                <rect 
                    id="NE" 
                    x="320" y="140" width="70" height="40" 
                    fill={getStateColor('NE', selectedMetric, stateData)}
                    {...getStrokeStyle('NE')}
                    onClick={() => onStateClick('NE')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="355" y="165" textAnchor="middle" fontSize="12">NE</text>
                
                <rect 
                    id="KS" 
                    x="320" y="185" width="70" height="40" 
                    fill={getStateColor('KS', selectedMetric, stateData)}
                    {...getStrokeStyle('KS')}
                    onClick={() => onStateClick('KS')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="355" y="210" textAnchor="middle" fontSize="12">KS</text>
                
                <rect 
                    id="OK" 
                    x="320" y="230" width="70" height="40" 
                    fill={getStateColor('OK', selectedMetric, stateData)}
                    {...getStrokeStyle('OK')}
                    onClick={() => onStateClick('OK')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="355" y="255" textAnchor="middle" fontSize="12">OK</text>
                
                <rect 
                    id="TX" 
                    x="280" y="310" width="110" height="100" 
                    fill={getStateColor('TX', selectedMetric, stateData)}
                    {...getStrokeStyle('TX')}
                    onClick={() => onStateClick('TX')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="335" y="365" textAnchor="middle" fontSize="12">TX</text>
                
                <rect 
                    id="MN" 
                    x="395" y="50" width="60" height="60" 
                    fill={getStateColor('MN', selectedMetric, stateData)}
                    {...getStrokeStyle('MN')}
                    onClick={() => onStateClick('MN')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="425" y="85" textAnchor="middle" fontSize="12">MN</text>
                
                <rect 
                    id="IA" 
                    x="395" y="115" width="60" height="40" 
                    fill={getStateColor('IA', selectedMetric, stateData)}
                    {...getStrokeStyle('IA')}
                    onClick={() => onStateClick('IA')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="425" y="140" textAnchor="middle" fontSize="12">IA</text>
                
                <rect 
                    id="MO" 
                    x="395" y="160" width="60" height="50" 
                    fill={getStateColor('MO', selectedMetric, stateData)}
                    {...getStrokeStyle('MO')}
                    onClick={() => onStateClick('MO')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="425" y="190" textAnchor="middle" fontSize="12">MO</text>
                
                <rect 
                    id="AR" 
                    x="395" y="215" width="60" height="50" 
                    fill={getStateColor('AR', selectedMetric, stateData)}
                    {...getStrokeStyle('AR')}
                    onClick={() => onStateClick('AR')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="425" y="245" textAnchor="middle" fontSize="12">AR</text>
                
                <rect 
                    id="LA" 
                    x="395" y="270" width="60" height="50" 
                    fill={getStateColor('LA', selectedMetric, stateData)}
                    {...getStrokeStyle('LA')}
                    onClick={() => onStateClick('LA')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="425" y="300" textAnchor="middle" fontSize="12">LA</text>
                
                <rect 
                    id="WI" 
                    x="460" y="50" width="50" height="50" 
                    fill={getStateColor('WI', selectedMetric, stateData)}
                    {...getStrokeStyle('WI')}
                    onClick={() => onStateClick('WI')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="485" y="80" textAnchor="middle" fontSize="12">WI</text>
                
                <rect 
                    id="IL" 
                    x="460" y="105" width="50" height="60" 
                    fill={getStateColor('IL', selectedMetric, stateData)}
                    {...getStrokeStyle('IL')}
                    onClick={() => onStateClick('IL')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="485" y="140" textAnchor="middle" fontSize="12">IL</text>
                
                <rect 
                    id="MS" 
                    x="460" y="240" width="40" height="60" 
                    fill={getStateColor('MS', selectedMetric, stateData)}
                    {...getStrokeStyle('MS')}
                    onClick={() => onStateClick('MS')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="480" y="275" textAnchor="middle" fontSize="12">MS</text>
                
                <rect 
                    id="IN" 
                    x="515" y="105" width="40" height="60" 
                    fill={getStateColor('IN', selectedMetric, stateData)}
                    {...getStrokeStyle('IN')}
                    onClick={() => onStateClick('IN')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="535" y="140" textAnchor="middle" fontSize="12">IN</text>
                
                <rect 
                    id="KY" 
                    x="515" y="170" width="70" height="35" 
                    fill={getStateColor('KY', selectedMetric, stateData)}
                    {...getStrokeStyle('KY')}
                    onClick={() => onStateClick('KY')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="550" y="192" textAnchor="middle" fontSize="12">KY</text>
                
                <rect 
                    id="TN" 
                    x="460" y="210" width="90" height="25" 
                    fill={getStateColor('TN', selectedMetric, stateData)}
                    {...getStrokeStyle('TN')}
                    onClick={() => onStateClick('TN')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="505" y="227" textAnchor="middle" fontSize="12">TN</text>
                
                <rect 
                    id="AL" 
                    x="505" y="240" width="40" height="60" 
                    fill={getStateColor('AL', selectedMetric, stateData)}
                    {...getStrokeStyle('AL')}
                    onClick={() => onStateClick('AL')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="525" y="275" textAnchor="middle" fontSize="12">AL</text>
                
                <rect 
                    id="MI" 
                    x="515" y="50" width="50" height="50" 
                    fill={getStateColor('MI', selectedMetric, stateData)}
                    {...getStrokeStyle('MI')}
                    onClick={() => onStateClick('MI')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="540" y="80" textAnchor="middle" fontSize="12">MI</text>
                
                <rect 
                    id="OH" 
                    x="560" y="105" width="50" height="50" 
                    fill={getStateColor('OH', selectedMetric, stateData)}
                    {...getStrokeStyle('OH')}
                    onClick={() => onStateClick('OH')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="585" y="135" textAnchor="middle" fontSize="12">OH</text>
                
                <rect 
                    id="WV" 
                    x="590" y="160" width="40" height="40" 
                    fill={getStateColor('WV', selectedMetric, stateData)}
                    {...getStrokeStyle('WV')}
                    onClick={() => onStateClick('WV')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="610" y="185" textAnchor="middle" fontSize="12">WV</text>
                
                <rect 
                    id="VA" 
                    x="635" y="160" width="60" height="40" 
                    fill={getStateColor('VA', selectedMetric, stateData)}
                    {...getStrokeStyle('VA')}
                    onClick={() => onStateClick('VA')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="665" y="185" textAnchor="middle" fontSize="12">VA</text>
                
                <rect 
                    id="NC" 
                    x="590" y="205" width="80" height="30" 
                    fill={getStateColor('NC', selectedMetric, stateData)}
                    {...getStrokeStyle('NC')}
                    onClick={() => onStateClick('NC')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="630" y="225" textAnchor="middle" fontSize="12">NC</text>
                
                <rect 
                    id="SC" 
                    x="590" y="240" width="60" height="40" 
                    fill={getStateColor('SC', selectedMetric, stateData)}
                    {...getStrokeStyle('SC')}
                    onClick={() => onStateClick('SC')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="620" y="265" textAnchor="middle" fontSize="12">SC</text>
                
                <rect 
                    id="GA" 
                    x="550" y="270" width="50" height="60" 
                    fill={getStateColor('GA', selectedMetric, stateData)}
                    {...getStrokeStyle('GA')}
                    onClick={() => onStateClick('GA')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="575" y="305" textAnchor="middle" fontSize="12">GA</text>
                
                <rect 
                    id="FL" 
                    x="550" y="335" width="60" height="80" 
                    fill={getStateColor('FL', selectedMetric, stateData)}
                    {...getStrokeStyle('FL')}
                    onClick={() => onStateClick('FL')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="580" y="380" textAnchor="middle" fontSize="12">FL</text>
                
                <rect 
                    id="PA" 
                    x="615" y="105" width="70" height="40" 
                    fill={getStateColor('PA', selectedMetric, stateData)}
                    {...getStrokeStyle('PA')}
                    onClick={() => onStateClick('PA')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="650" y="130" textAnchor="middle" fontSize="12">PA</text>
                
                <rect 
                    id="NY" 
                    x="650" y="50" width="70" height="50" 
                    fill={getStateColor('NY', selectedMetric, stateData)}
                    {...getStrokeStyle('NY')}
                    onClick={() => onStateClick('NY')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="685" y="80" textAnchor="middle" fontSize="12">NY</text>
                
                <rect 
                    id="VT" 
                    x="725" y="50" width="25" height="40" 
                    fill={getStateColor('VT', selectedMetric, stateData)}
                    {...getStrokeStyle('VT')}
                    onClick={() => onStateClick('VT')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="737" y="75" textAnchor="middle" fontSize="10">VT</text>
                
                <rect 
                    id="NH" 
                    x="755" y="50" width="25" height="40" 
                    fill={getStateColor('NH', selectedMetric, stateData)}
                    {...getStrokeStyle('NH')}
                    onClick={() => onStateClick('NH')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="767" y="75" textAnchor="middle" fontSize="10">NH</text>
                
                <rect 
                    id="ME" 
                    x="785" y="30" width="40" height="60" 
                    fill={getStateColor('ME', selectedMetric, stateData)}
                    {...getStrokeStyle('ME')}
                    onClick={() => onStateClick('ME')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="805" y="65" textAnchor="middle" fontSize="12">ME</text>
                
                <rect 
                    id="MA" 
                    x="740" y="95" width="50" height="25" 
                    fill={getStateColor('MA', selectedMetric, stateData)}
                    {...getStrokeStyle('MA')}
                    onClick={() => onStateClick('MA')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="765" y="110" textAnchor="middle" fontSize="10">MA</text>
                
                <rect 
                    id="RI" 
                    x="795" y="95" width="20" height="25" 
                    fill={getStateColor('RI', selectedMetric, stateData)}
                    {...getStrokeStyle('RI')}
                    onClick={() => onStateClick('RI')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="805" y="110" textAnchor="middle" fontSize="10">RI</text>
                
                <rect 
                    id="CT" 
                    x="740" y="125" width="50" height="25" 
                    fill={getStateColor('CT', selectedMetric, stateData)}
                    {...getStrokeStyle('CT')}
                    onClick={() => onStateClick('CT')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="765" y="140" textAnchor="middle" fontSize="10">CT</text>
                
                <rect 
                    id="NJ" 
                    x="690" y="125" width="30" height="40" 
                    fill={getStateColor('NJ', selectedMetric, stateData)}
                    {...getStrokeStyle('NJ')}
                    onClick={() => onStateClick('NJ')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="705" y="150" textAnchor="middle" fontSize="10">NJ</text>
                
                <rect 
                    id="DE" 
                    x="700" y="170" width="25" height="30" 
                    fill={getStateColor('DE', selectedMetric, stateData)}
                    {...getStrokeStyle('DE')}
                    onClick={() => onStateClick('DE')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="712" y="190" textAnchor="middle" fontSize="10">DE</text>
                
                <rect 
                    id="MD" 
                    x="650" y="150" width="45" height="25" 
                    fill={getStateColor('MD', selectedMetric, stateData)}
                    {...getStrokeStyle('MD')}
                    onClick={() => onStateClick('MD')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="672" y="165" textAnchor="middle" fontSize="10">MD</text>
                
                {/* Alaska and Hawaii */}
                <rect 
                    id="AK" 
                    x="50" y="400" width="80" height="60" 
                    fill={getStateColor('AK', selectedMetric, stateData)}
                    {...getStrokeStyle('AK')}
                    onClick={() => onStateClick('AK')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="90" y="435" textAnchor="middle" fontSize="12">AK</text>
                
                <rect 
                    id="HI" 
                    x="150" y="420" width="40" height="30" 
                    fill={getStateColor('HI', selectedMetric, stateData)}
                    {...getStrokeStyle('HI')}
                    onClick={() => onStateClick('HI')}
                    style={{ cursor: 'pointer' }}
                />
                <text x="170" y="440" textAnchor="middle" fontSize="12">HI</text>
            </svg>
        </div>
    );
};

export default USMap;